export default "__VITE_ASSET__DWryIOdA__"